module.exports = __webpack_public_path__ + "static/media/arab12.98f8ea93.wav";